import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Card as ReactstrapCard,
    CardBody,
    CardHeader,
    Col,
    Row,
    // TabContent,
    TabPane,
    Button,
    Alert
} from 'reactstrap';
import classnames from 'classnames';
import * as routes from '../../../routes';
import PatientDetailsNav from "./patientDetailsNav";
import PatientDetails from "./patientDetails";
import PatientCoverage from "./patientCoverage";
import { startBookingProcess } from "actions/rd2RefactorActions";
import { defaultBookingDisabledMessage } from '../../../lib/misc';
import '../css/patientDetailsTabbedCollapsable.css';
import withPermission from "@/components/common/withPermission";
import Mhd2Permissions from "@/constants/permissions";
import { ActiveTabProvider, useActiveTab } from "./activeTabContext";
import { PatientInfoTabName, TabContent } from "../patientDetailsView";

export default function PatientDetailsTabbedCollapsable(
) {
    const patient = useSelector((state: any) => state.activePatient);
    const patientConfig = useSelector((state: any) => state.config.patient);
    const routePrefix = useSelector((state: any) => state.config.instance.routePrefix);

    return (
        <ActiveTabProvider initialTab={PatientInfoTabName.patientDetails} >
            <Card >
                <PatientDetailsHeader
                    patient={patient}
                    config={patientConfig}
                    routePrefix={routePrefix}
                />
                <CardBody className="PatientDetailsCardBody">
                    <PatientDetailsNav />
                    <TabContent >
                        <TabPane tabId={PatientInfoTabName.patientDetails}>
                            <PatientDetails
                                config={patientConfig}
                                patient={patient}
                            />
                        </TabPane>
                        <TabPane tabId={PatientInfoTabName.coverage}>
                            <PatientCoverage />
                        </TabPane>
                    </TabContent>
                </CardBody>
            </Card>
        </ActiveTabProvider>
    );
}

const PatientDetailsHeader = ({ patient, config, routePrefix }: { patient: any, config: any, routePrefix: any }) => (
    <CardHeader className="PatientDetailsCardHeader">
        <Row style={{ alignItems: "baseline" }}>
            <Col lg="auto" style={{ paddingLeft: "0px" }}>
                <PatientName patient={patient} />
            </Col>
            <Col>
                {config.isEditEnabled &&
                    <ProtectedPatientEditToggle patient={patient} routePrefix={routePrefix} />
                }
            </Col>
            <Col lg="auto" style={{ paddingRight: "0px" }}>
                <ProtectedBookAppointmentButton patient={patient} />
            </Col>
        </Row>

    </CardHeader>
);

const PatientName = ({ patient }: { patient: any }) => {
    return (
        <h4>
            {patient.details.firstName} {patient.details.lastName}
        </h4>
    )
}

const PatientEditToggle = ({ patient, routePrefix }: { patient: any, routePrefix: any }) => {
    const dispatch = useDispatch();
    return <h4>
        <a
            href="#Edit"
            onClick={
                (e) => {
                    e.preventDefault();
                    dispatch(routes.patientEdit(routePrefix, patient.details.referenceId))
                }}
            style={{ color: 'black' }}
        >
            <FontAwesomeIcon icon="user-edit" />
        </a>
    </h4>
}
const ProtectedPatientEditToggle = withPermission<{ patient: any, routePrefix: any }>(Mhd2Permissions.patientManagement)(PatientEditToggle);

const BookAppointmentButton = ({ patient }: { patient: any }) => {
    const dispatch = useDispatch();

    const activeCareOrder = useSelector((state: any) => state.careOrder);
    const decisionSupportOutput = useSelector((state: any) => state.decisionSupport);
    const availabilitySearchConfig = useSelector((state: any) => state.config.availabilitySearch);
    const activePatientDetails = useSelector((state: any) => state.activePatient.details);
    const useDecisionSupport = useSelector((state: any) => state.config.decisionSupport.useDecisionSupport);
    const routePrefix = useSelector((state: any) => state.config.instance.routePrefix);

    return (
        <>
            {!patient.details.isBookingDisabled ? (
                <Button
                    color="primary"
                    onClick={
                        () => {
                            dispatch(startBookingProcess(
                                activeCareOrder,
                                decisionSupportOutput,
                                availabilitySearchConfig,
                                activePatientDetails,
                                useDecisionSupport,
                                routePrefix,
                            ))
                        }
                    }
                >
                    Book Appointment
                </Button>
            ) : (
                <Alert color="danger">{patient.details.bookingDisabledMessage ?? defaultBookingDisabledMessage}</Alert>
            )}
        </>
    )
}
const ProtectedBookAppointmentButton = withPermission<{ patient: any }>(Mhd2Permissions.appointmentManagement)(BookAppointmentButton);

type CardProps = React.ComponentProps<typeof ReactstrapCard>

const Card: React.FC<CardProps> = (props) => {
    const { activeTab } = useActiveTab();
    return <ReactstrapCard className={classnames({ PatientDetailsCard: !activeTab, PatientDetailsCardActive: activeTab })} {...props} />
}